import React from "react";

// Same logo the app has always used.
export const LOGO_URL = "https://thelandschaft.com/wp-content/uploads/2024/09/cropped-8x8-01-768x498.png";

// The source PNG (768x498, transparent background) is the circular teal
// "LS" icon stacked above a "Landschaft" wordmark rendered in dark navy -
// fine on a white page, unreadable on the app's dark navy sidebar/panels,
// which was previously "solved" by dropping the whole image on a white
// chip (reads as a sticker slapped on a dark nav, not a logo that belongs
// there). Cropping to just the icon (verified against the actual pixels:
// icon occupies roughly x217-550, y20-338) gives a mark whose own teal
// tone already has good contrast on dark navy, so it can sit directly on
// the sidebar - paired with "Landschaft" set as real, controllable text
// instead of baked into the image.
const CROP = { x: 200, y: 5, size: 370 };
const NATURAL = { width: 768, height: 498 };

const LogoMark = ({ size = 36, className = "" }) => {
  const scale = size / CROP.size;
  return (
    <span
      role="img"
      aria-label="Landschaft"
      className={`inline-block shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${LOGO_URL})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: `${NATURAL.width * scale}px ${NATURAL.height * scale}px`,
        backgroundPosition: `${-CROP.x * scale}px ${-CROP.y * scale}px`,
      }}
    />
  );
};

export default LogoMark;
